module.exports = __webpack_public_path__ + "static/media/simulation-select-percent-icon.e12ceb8a.svg";